import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { OrganisationsService } from '../../services';

@Component({
  selector: 'page-org-structure-customer',
  templateUrl: './org-structure-customer.component.html',
})
export class OrgStructureCustomerComponent implements OnInit {
  public backTo: string;

  public id: number;
  public customerorgId: number;

  constructor(
    private orgService: OrganisationsService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.orgService.getCurrentUserOrgTypeId().then((res) => {
      this.customerorgId = res;
      console.log('this.customerorgTYPEId');
      console.log(this.customerorgId);
    });
  }

  close() {
    this.router.navigate([this.backTo]);
  }
}
